import { clientEntity } from "./client-entity";
import { Model } from "@vuex-orm/core";
import { clientLocationEntity } from "./client-location-entity";

function ormDateStringToJs(value: unknown): Date | null {
  if (value != null) {
    return new Date(value as string);
  }
  return null;
}

export interface contactEntity {
  contactId: number;
  firstName: string;
  middleName: string;
  lastName: string;
  emailAddress: string;
  contactStatusId?: number;
  clientLocationId?: number;
  address: string;
  createdOn: string;
  updatedOn: string;
  fullNameWithClientName: string;
  city: string;
  state: string;
  country: string;
  countryCode: string;
  cellPhoneNo: string;
  phone: string;
  phoneExt: string;
  clientId: number;
  clientLocationName: string;
  secondaryAddress: string;
  jobTitle: string;
  departmentName: string;
  clientEntity: clientEntity;
  status: string;
  timeZone: string;
  tick?: number;
  isActionButtonOpen: boolean;
  isFilling: boolean;
  isBillingContact: boolean;
  isAccessible: boolean;
  isTemporaryContact: boolean;
  tagIds: number[];
  description: string;
}

export class contactEntity extends Model {
  static entity = "contactEntity";
  static primaryKey = "contactId";
  static fields() {
    return {
      contactId: this.number(0),
      firstName: this.string(""),
      middleName: this.string("").nullable(),
      lastName: this.string(""),
      emailAddress: this.string(""),
      contactStatusId: this.number(null).nullable(),
      clientLocationId: this.number(null).nullable(),
      address: this.string(""),
      createdOn: this.attr(""),
      updatedOn: this.attr(""),
      fullNameWithClientName: this.attr(""),
      city: this.string(""),
      state: this.string(""),
      country: this.string(""),
      countryCode: this.string("").nullable(),
      cellPhoneNo: this.string("").nullable(),
      phone: this.string("").nullable(),
      phoneExt: this.string("").nullable(),
      clientId: this.number(0),
      clientLocationName: this.string(""),
      secondaryAddress: this.attr("").nullable(),
      jobTitle: this.string("").nullable(),
      departmentName: this.string("").nullable(),
      clientEntity: this.hasOne(clientEntity, "clientId", "clientId"),
      status: this.string(""),
      timeZone: this.attr(null),
      tick: this.number(0),
      isActionButtonOpen: this.boolean(false), //will only be used for UI
      isFilling: this.boolean(true),
      isBillingContact: this.boolean(null),
      isAccessible: this.boolean(true),
      isTemporaryContact: this.boolean(false),
      tagIds: this.attr([]),
      description: this.attr(""),
    };
  }

  static afterCreate(_record: any) {}

  static afterUpdate(_record: any) {}

  static beforeSelect(records: any) {
    return records.filter((row: any) => row.contactId != 0);
  }

  get fullNameWithEmail() {
    let fullName = `${this.fullNameWithoutClientName}`;

    if (this.emailAddress != null && this.emailAddress != "") {
      fullName += ` <${this.emailAddress}>`;
    }

    return fullName;
  }

  get fullName() {
    let client = clientEntity
      .query<any>()
      .where("clientId", this.clientId)
      .first();
    if (client && client.clientName) {
      return (
        this.firstName + " " + this.lastName + " (" + client.clientName + ")"
      );
    }
    return this.firstName + " " + this.lastName;
  }

  get fullNameWithoutClientName() {
    return this.firstName + " " + this.lastName;
  }

  get clientName() {
    let client = clientEntity
      .query<any>()
      .where("clientId", this.clientId)
      .first();
    if (client && client.clientName) {
      return "(" + client.clientName + ")";
    }
    return "";
  }

  get fullNameWithoutClientNameForSort() {
    return this.firstName.toLowerCase() + " " + this.lastName.toLowerCase();
  }

  get jsCreatedOn() {
    return ormDateStringToJs(this.createdOn);
  }

  get jsUpdatedOn() {
    return ormDateStringToJs(this.updatedOn);
  }

  get clientLocationEntity() {
    if (this.clientLocationId != null && this.clientLocationId > 0) {
      return clientLocationEntity
        .query<any>()
        .where("clientLocationId", this.clientLocationId)
        .first();
    }
    return null;
  }
}
